export const deskTopPopupWidth = "640px"
export const mobilePopupWidth = "100%"
export const desktopPopupHeight = "fit-content"
export const mobilePopupHeight = "100vh"
export const baseGrid = 8
export const topbarHeight = 75
export const mobileTopbarHeight = 124
export const mobileTopBarAndCategoryListHeight = 158
export const MIN_PASSWORD_LENGTH = 8
export const TENSECONDS = 10000
export const TWENTYSECONDS = 20000
